module.exports = __webpack_public_path__ + "img/1724827370211-donat.jpg.c436a1fe.webp";